import type { PaginatedResponse } from "types/DataTypes";

import { api } from "./api.ts";

export type UserType = {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  user_type: string;
  is_active: boolean;
  is_pending_approval: boolean;
  organization: number | null;
};

export const usersAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getUsers: build.query<
      PaginatedResponse<UserType>,
      {
        isPendingApproval?: boolean;
        clientId?: number;
        userType?: string;
        hasClientIntakeAuthority?: boolean;
        isRejected?: boolean;
        page?: number;
        pageSize?: number;
      }
    >({
      query: ({
        isPendingApproval,
        clientId,
        userType,
        hasClientIntakeAuthority,
        isRejected,
        page,
        pageSize,
      }) => ({
        url: "api/v1/users/",
        method: "GET",
        params: {
          ...(isPendingApproval !== undefined
            ? { is_pending_approval: isPendingApproval }
            : {}),
          ...(clientId !== undefined ? { client: clientId } : {}),
          ...(userType !== undefined ? { user_type: userType } : {}),
          ...(hasClientIntakeAuthority !== undefined
            ? { has_client_intake_authority: hasClientIntakeAuthority }
            : {}),
          ...(isRejected !== undefined ? { is_rejected: isRejected } : {}),
          ...(page !== undefined ? { page } : {}),
          ...(pageSize !== undefined ? { page_size: pageSize } : {}),
        },
      }),
      providesTags: ["Users"],
    }),
    approveUser: build.mutation<UserType, { id: number | string }>({
      query: ({ id }) => ({
        url: `api/v1/users/${id}/approve/`,
        method: "POST",
        body: {},
      }),
      invalidatesTags: ["Users", "IntakeUsers"],
    }),
    rejectUser: build.mutation<
      UserType,
      { id: number | string; reason: string }
    >({
      query: ({ id, reason }) => ({
        url: `api/v1/users/${id}/reject/`,
        method: "POST",
        body: { reason },
      }),
      invalidatesTags: ["Users", "IntakeUsers"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUsersQuery,
  useApproveUserMutation,
  useRejectUserMutation,
} = usersAPI;
